export default __webpack_public_path__ + "images/a3436a14940886717aa6f289eac4677d.webp";